import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { box, text, grid, boxCustom, line, textWrap, labelValue, addAnuladoWatermark } from "../pdfDraw";
import { formatDate, formatDecimal, formatText, formatMoney, formatDecimalSpecial } from "../../formatters";
// (2026-08-14, defecto B) Comparación del estatus en su fuente única. Antes se
// comparaba aquí a mano y sensible a mayúsculas: ver `utils/guiaEstatus.js`.
import { esGuiaAnulada } from "../../guiaEstatus";
import exampleLogo from "../../../assets/img/react.jpg";
import QRCode from "qrcode";
import { encryptText } from '../../../controllers/api';

/* ================================================= */
export const buildDispacheGuidesPDF = async (data, dispacheGuideId, mode = "download") => {

  //const data = await getRetencionISLR(comprobante_id);
  if (!data) return;

  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "letter"
  });

  const g = grid();
  const col12 = g.col(0, 12);

  let y = 10;

  const {
    documento,
    emisor,
    destinatario,
    items,
    totales,
    transporte,
    referencia_factura,
    legal
  } = data;

  /* ================================================= */
  /* ================= HEADER ======================== */
  /* ================================================= */

  const headerHeight = 30;

  const colLogo = g.col(0, 2);
  const colRender = g.col(3, 1);
  const colCenter = g.col(4, 3);
  const colRight = g.col(7, 4);
  const colQr = g.col(10, 2);

  // BORDE GENERAL (único)
  box(doc, col12.x, y, col12.w, headerHeight);

  /* ---------- LOGO ---------- */

  const logoY = y + 3;
  const logoH = headerHeight - 6;

  const logoImage = emisor?.logo_base64 || exampleLogo;

  try {
    doc.addImage(
      logoImage,
      emisor?.logo_base64 ? "PNG" : "JPG",
      colLogo.x + 2,
      logoY,
      colLogo.w - 4,
      logoH
    );
  } catch (err) {
    console.warn("Error cargando logo, usando fallback");

    doc.addImage(
      exampleLogo,
      "JPG",
      colLogo.x + 4,
      logoY,
      colLogo.w - 4,
      logoH
    );
  }

  /* ---------- QR ---------- */

  const baseUrl = window.location.origin;

  const qrUrl = `${baseUrl}/document/DG/${encodeURIComponent(encryptText(documento.qr_token.toString()))}/`;

  const qrBase64 = await QRCode.toDataURL(qrUrl, {
    width: 120,
    margin: 1
  });
  /*
   * @param {object} doc - Instancia de jsPDF
   * @param {number} x - Posición X inicial
   * @param {number} y - Posición Y inicial
   * @param {number} w - Ancho de la caja
   * @param {number} h - Alto de la caja
   * @param {string|array} fillColor - Color de fondo (hex o RGB) (default "#FFFFFF")
   * @param {number} borderRadius - Radio de los bordes (default 0)
   * @param {number} borderWidth - Grosor del borde en mm (default 0, sin borde)
   * @param {string|array} borderColor - Color del borde (hex o RGB) (default "#000000")
  */
  boxCustom(doc, colQr.x + 14, logoY - 1, logoH + 2, logoH + 2, "#ffffff", 2, 0.5, "#4a4a4a");
  //const qrSize = 17 + 3;
  doc.addImage(
    qrBase64,
    "PNG",
    colQr.x + 15,
    logoY,
    logoH,
    logoH
  );

  /* ---------- CENTRO ---------- */

  text(
    doc,
    formatText("Guía de despacho"),
    colCenter.x + colCenter.w / 2,
    y + 10,
    11,
    "center",
    true
  );

  if (documento.numero_guia){
    text(
      doc,
      formatText(documento.numero_guia),
      colCenter.x + colCenter.w / 2,
      y + 16,
      11,
      "center",
      true
    );
  }

  text(
    doc,
    `Fecha de emisión: ${formatDate(referencia_factura.fecha_emision)}`,
    colCenter.x + colCenter.w / 2,
    y + ((documento.numero_guia == "" || documento.numero_guia == null) ? 16 : 22),
    9,
    "center"
  );

  /* ---------- DERECHA (SIN CAJAS) ---------- */

  const rightX = colRight.x + 2;
  labelValue(
    doc,
    "Nº de control",
    formatText(documento.numero_control_guia) || "",
    rightX,
    y + 6
  );

  labelValue(
    doc,
    "Fecha de sálida",
    formatDate(documento.fecha_salida) + ' ' + formatText(documento.hora_salida),
    rightX,
    y + 11
  );

  labelValue(
    doc,
    "Nº de factura",
    referencia_factura.numero_documento || referencia_factura.numero_factura,
    rightX,
    y + 16
  );

  labelValue(
    doc,
    "Nº de control factura",
    formatText(referencia_factura.numero_control),
    rightX,
    y + 21
  );

  labelValue(
    doc,
    "Fecha emisión",
    formatDate(referencia_factura.fecha_emision),
    rightX,
    y + 26
  );

  y += headerHeight + 4;

  /* ================================================= */
  /* ========= PROVEEDOR / EMPRESA =================== */
  /* ================================================= */

  const hInfo = 28;

  const colLeft = g.col(0, 4);
  const colCenterInfo = g.col(4, 4);
  const colRightInfo = g.col(8, 4);

  // Proveedor
  box(doc, colLeft.x, y, colLeft.w, hInfo);

  text(doc, "Proveedor/Beneficiario:", colLeft.x + 2, y + 5, 8, "left", true);
  text(doc, formatText(emisor.nombre_empresa), colLeft.x + 2, y + 9);
  //text(doc, `RIF: ${formatText(emisor.rif)}`, colLeft.x + 2, y + 15);
  labelValue(
    doc,
    "RIF",
    formatText(emisor.rif),
    colLeft.x + 2,
    y + 13
  );
  labelValue(
    doc,
    "Dirección",
    "",
    colLeft.x + 2,
    y + 17
  );

  textWrap(
    doc,
    "                    " + formatText(emisor.direccion || ""),
    colLeft.x + 2,
    y + 17,
    colLeft.w - 2,
    9,
    "justify",
    false,
    4
  );

  // Empresa
  box(doc, colCenterInfo.x, y, colCenterInfo.w, hInfo);

  text(doc, "Empresa:", colCenterInfo.x + 2, y + 5, 8, "left", true);
  text(doc, formatText(destinatario.nombre), colCenterInfo.x + 2, y + 9);
  //text(doc, `RIF: ${formatText(destinatario.rif)}`, colRightInfo.x + 2, y + 15);
  labelValue(
    doc,
    "RIF",
    formatText(destinatario.rif),
    colCenterInfo.x + 2,
    y + 13
  );
  labelValue(
    doc,
    "Dirección",
    "",
    colCenterInfo.x + 2,
    y + 17
  );

  textWrap(
    doc,
    "                    " + formatText(destinatario.direccion || ""),
    colCenterInfo.x + 2,
    y + 17,
    colCenterInfo.w - 2,
    9,
    "justify",
    false,
    4
  );

  // Info transporte
  box(doc, colRightInfo.x, y, colRightInfo.w, hInfo);

  text(doc, "Detalle del transporte:", colRightInfo.x + 2, y + 5, 8, "left", true);
  //text(doc, formatText(destinatario.nombre), colRightInfo.x + 2, y + 10);
  labelValue(
    doc,
    "Ubic. de origen",
    formatText(transporte.origen),
    colRightInfo.x + 2,
    y + 9
  );
  labelValue(
    doc,
    "Dir. de destino",
    "",
    colRightInfo.x + 2,
    y + 13
  );
  var trpY = y + 13;
  trpY = textWrap(
    doc,
    "                            " + formatText(transporte.destino || ""),
    colRightInfo.x + 2,
    trpY,
    colRightInfo.w - 2,
    9,
    "justify",
    false,
    4
  );
  labelValue(
    doc,
    "Motivo",
    formatText(transporte.motivo_traslado) || "",
    colRightInfo.x + 2,
    trpY
  );
  /*labelValue(
    doc,
    "Placa del vehículo",
    formatText(transporte.placa) || "",
    colRightInfo.x + 2,
    y + 25
  );*/

  y += hInfo + 5;

  /* ================================================= */
  /* ===== CLASIFICACIÓN PRODUCTO / SERVICIO (A11) ==== */
  /* ================================================= */
  // (2026-07-18 A11) Tipo de producto (literal del catálogo o código) y
  // descripción del servicio (tabla 28). Se imprime SOLO si viene el dato; si
  // ambos están vacíos, no se dibuja nada (ni se consume alto de página).
  const _tipoProd = formatText(documento.tipo_producto || "");
  const _descServ = formatText(documento.descripcion_servicio || "");
  if (_tipoProd || _descServ) {
    if (_tipoProd) {
      labelValue(doc, "Tipo de producto", _tipoProd, colLeft.x, y, 9);
    }
    if (_descServ) {
      labelValue(doc, "Descripción del servicio", _descServ, colCenterInfo.x, y, 9);
    }
    y += 6;
  }

  /* ================================================= */
  /* ================= TABLA ========================= */
  /* ================================================= */

  const tableData = items.map(d => [
    formatText(d.descripcion),
    formatDecimal(d.cantidad),
    formatDecimalSpecial(d.peso_unitario_kg, 3),
    formatDecimalSpecial(d.masa_kg, 3),
    formatDecimal(d.capacidad),
    formatDecimalSpecial(d.volumen_unitario_m3, 4),
    formatDecimalSpecial(d.volumen, 4),
    formatText(d.unidad_medida),
    // (2026-07-18 A11) Alícuota IVA por ítem (heredada de la factura vinculada).
    // '' si el ítem no matchea un producto con categoría IVA.
    (d.alicuota_iva ? formatDecimal(d.alicuota_iva) + "%" : ""),
  ]);

  autoTable(doc, {
    startY: y,
    head: [[
      "Descripción",
      "Cantidad",
      "Peso Unit. (Kg)",
      "Peso (Kg)",
      "Capacidad",
      "Volumen Unit. (M³)",
      "Volumen (M³)",
      "Unidad de medida",
      "Alícuota IVA",
    ]],
    body: tableData,
    foot: [[
      "", "", "", "", "", "", "", "", "",
    ]],
    theme: "grid",
    styles: { fontSize: 8 },
    headStyles: { fillColor: [220,220,220], textColor:0, fontStyle: "bold", halign: "center" },
    footStyles: { fillColor: [220,220,220], textColor:0, fontStyle: "bold", halign: "right" },
    columnStyles: {
        0: {halign:'left'},
        1: {halign:'center'},
        2: {halign:'center'},
        3:{halign:'center'},
        4:{halign:'center'},
        5:{halign:'center'},
        6:{halign:'center'},
        7:{halign:'center'},
        8:{halign:'center'},
    },
    margin: { left: col12.x, right: 10 },
    tableWidth: col12.w,
    // (2026-05-22) Marca de agua replicada de invoicesPDF.js (su seccion
    // didDrawPage). En cada pagina dibuja, en gris tenue y repetido
    // verticalmente, el texto "DOCUMENTO SIN DERECHO A CREDITO FISCAL".
    // A diferencia de la factura (que solo lo marca en las copias via
    // `es_copia`), una GUIA DE DESPACHO nunca otorga credito fiscal por
    // su naturaleza, por lo que la marca se muestra siempre.
    didDrawPage: function (data) {
      const pageWidth = doc.internal.pageSize.width;
      const pageHeight = doc.internal.pageSize.height;

      doc.saveGraphicsState();

      try {
        doc.setGState(new doc.GState({ opacity: 0.08 }));
      } catch (e) {
        // fallback por si GState no aplica en esta version de jsPDF
      }

      doc.setFont("helvetica", "bold");
      doc.setFontSize(22);
      doc.setTextColor(180, 180, 180);

      // Repeticiones distribuidas uniformemente en el alto de la pagina
      // (la guia es landscape-letter; el calculo dinamico se adapta a
      // cualquier formato/orientacion).
      const repeticiones = 5;
      for (let i = 1; i <= repeticiones; i++) {
        doc.text(
          "DOCUMENTO SIN DERECHO A CRÉDITO FISCAL",
          pageWidth / 2,
          (pageHeight * i) / (repeticiones + 1),
          { align: "center", angle: 0 }
        );
      }

      doc.restoreGraphicsState();

      // Reset explicito de fuente/tamaño/color para no contaminar el
      // texto que se dibuja despues del autoTable (footer de la guia).
      doc.setFont("helvetica", "normal");
      doc.setFontSize(9);
      doc.setTextColor(0, 0, 0);
    }
  });

  /* ================================================= */
  /* ================= FOOTER ======================== */
  /* ================================================= */

  const footerHeight = 40;
  const footerTop = doc.internal.pageSize.height - footerHeight;

  labelValue(
    doc,
    "Total Neto",
    formatMoney(referencia_factura.total_neto),
    col12.x,
    footerTop - 10,
    9
  )

  labelValue(
    doc,
    "Nº de identificación del transportista",
    "   __________________________",
    col12.x,
    footerTop - 5,
    9
  )

  labelValue(
    doc,
    "Nombre del transportista",
    "                      " + (formatText(transporte.chofer) || "__________________________"),
    col12.x,
    footerTop,
    9
  );

  labelValue(
    doc,
    "Firma del transportista",
    "                          __________________________",
    col12.x,
    footerTop + 5,
    9
  );

  labelValue(
    doc,
    "Nº de identificación del receptor",
    "   __________________________",
    col12.x + 150,
    footerTop - 5,
    9
  )

  labelValue(
    doc,
    "Nombre del receptor",
    "                      __________________________",
    col12.x + 150,
    footerTop,
    9
  );

  labelValue(
    doc,
    "Firma del receptor",
    "                          __________________________",
    col12.x + 150,
    footerTop + 5,
    9
  );

  labelValue(
    doc,
    "Fecha de sálida",
    formatDate(documento.fecha_salida),
    col12.x,
    footerTop + 10,
    9
  );
  if (transporte.placa){
    labelValue(
      doc,
      "Placa del vehículo",
      "   " + formatText(transporte.placa),
      col12.x + 50,
      footerTop + 10,
      9
    );
  }

  const pageWidth = doc.internal.pageSize.width;
  const maxWidth = pageWidth - (8 * 2);

  y = textWrap(
    doc,
    formatText(legal.leyenda),
    8,       // X inicial
    footerTop + 15,            // Y inicial
    maxWidth,     // ancho máximo
    6,            // tamaño fuente
    "center",     // alineación centrada
    false,          // negrita
    3
  );

  // (2026-07-18 B1-bis) Línea legal del pie de la guía = campo `leyenda_legal`
  // del lote info_seniat (el backend lo entrega en data.legal.leyenda_legal,
  // leído del lote activo estado=True en tiempo de render). Se imprime VERBATIM
  // (SIN formatText/mayúsculas); si viene vacío, se omite. ANTES esta posición
  // componía "Imprenta Digital Autorizada mediante Providencia Administrativa
  // {nomenclatura} de fecha {fecha}"; el cliente definió que el texto del pie
  // proviene ÍNTEGRO de `leyenda_legal`.
  const _leyendaLegal = (data.legal.leyenda_legal || "").toString().trim();
  if (_leyendaLegal) {
    y = textWrap(
      doc,
      _leyendaLegal,
      8,       // X inicial
      footerTop + 18,            // Y inicial
      maxWidth,     // ancho máximo
      6,            // tamaño fuente
      "center",     // alineación centrada
      false,          // negrita
      3
    );
  }

  // (2026-07-08) Sello "ANULADO" en todas las páginas si la guía está anulada.
  // (2026-08-14, defecto B) La comparación era `=== "anulada"` / `=== "anulado"`,
  // SENSIBLE A MAYÚSCULAS: con el estatus 'ANULADA' que el alta llegó a
  // persistir como texto libre, el PDF salía SIN sello mientras la vista del QR
  // sí avisaba. `esGuiaAnulada` normaliza (trim + minúsculas) y es la misma
  // función que usa esa vista — una sola verdad para las dos capas.
  if (esGuiaAnulada(documento.estatus)) {
    const _pc = doc.getNumberOfPages();
    for (let _p = 1; _p <= _pc; _p++) { doc.setPage(_p); addAnuladoWatermark(doc, documento.fecha_anulacion); }
  }
  const pdfBlob = doc.output("blob");
  if(mode === "download"){
    doc.save(`GUIA_${documento.numero_guia || ""}.pdf`);
  } else {
    return URL.createObjectURL(pdfBlob);
  }
};